export enum SearchLevelEnum {
  Individual = 'Individual',
  Pack = 'Pack',
}